import React from "react";
import PropTypes from "prop-types";
import {Button} from "semantic-ui-react";

import PaymentDetailsPopup from './PaymentDetails';

const styles = {
  button: {
    fontFamily: 'monospace',
    minWidth: '450px',
    textAlign: 'left',
    fontSize: '90%'
  }
};

// A document in the list: a link to its page, or — for a payment, which has none — an (i)
// with the payment's card behind it (FIN-1346). `owner` is the document the list belongs to.
const RelatedDocItem = ({doc, owner}) => {
  const button = (
    <Button
      circular
      basic
      as={!doc.no_link && 'a'}
      href={!doc.no_link && doc.url}
      target="_blank"
      content={doc.title}
      icon={doc.no_link ? 'info' : 'external alternate'}
      labelPosition="right"
      style={styles.button}
    />
  );

  if (doc.no_link && doc.type === 'Payment') {
    return <PaymentDetailsPopup paymentId={doc.pk || doc.id} owner={owner} trigger={button} />;
  }

  return button;
}

RelatedDocItem.propTypes = {
  doc: PropTypes.object.isRequired,
  owner: PropTypes.shape({ type: PropTypes.string, id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]) })
};

export default RelatedDocItem;
